// @ts-nocheck

export const MPRoutesActionTypes = Object.freeze({
  OPEN_MP_VIEW: 'MONOPOLY:OPEN_MAIN_VIEW',
});
